import { useTranslation } from "react-i18next";
import { Button } from "components/ui/button";
import { Checkbox } from "components/ui/checkbox";
import { Label } from "components/ui/label";
import Dialog from "components/shared/Dialog";
import { Field } from "components/shared/Form";
import ResourceSelect from "components/shared/inputs/ResourceSelect";
import { getSettingsResourceSearchFilters, renderSettingsResourceLabel } from "utils/helpers/settings";
import type { OvertimeRuleType } from "./types";

type OvertimeRuleModalProps = {
    ruleType: OvertimeRuleType;
    title: string;
    ruleTitle: string;
    showCalculateOtherOvertime: boolean;
    disabled?: boolean;
    modalOpen: OvertimeRuleType | null;
    setModalOpen: (modalOpen: OvertimeRuleType | null) => void;
};

function OvertimeRuleModal({ ruleType, title, ruleTitle, showCalculateOtherOvertime, disabled, modalOpen, setModalOpen }: OvertimeRuleModalProps) {
    const { t } = useTranslation();

    if (modalOpen !== ruleType) return null;

    return (
        <Dialog
            open={modalOpen === ruleType}
            close={() => setModalOpen(null)}
            title={title}
            footer={
                <div className="tw-flex tw-justify-end tw-gap-2">
                    <Button type="button" variant="outline" onClick={() => setModalOpen(null)}>
                        {t("close")}
                    </Button>
                </div>
            }
        >
            <div className="tw-space-y-4">
                <p className="tw-text-sm tw-font-medium">{ruleTitle}</p>

                <Field name={`overtime.${ruleType}.payCode`} label={t("default-pay-code")}>
                    <ResourceSelect
                        renderLabel={renderSettingsResourceLabel}
                        resourcePath="/pay-code"
                        placeholder={t("pay-code")}
                        getSearchFilter={getSettingsResourceSearchFilters}
                        disabled={disabled}
                    />
                </Field>

                {showCalculateOtherOvertime && (
                    <Field name={`overtime.${ruleType}.calculateOtherOvertime`} valuePropName="checked">
                        <div className="tw-flex tw-items-center tw-gap-2">
                            <Checkbox disabled={disabled} />
                            <Label>{t("calculate-other-overtime")}</Label>
                        </div>
                    </Field>
                )}
            </div>
        </Dialog>
    );
}

export default OvertimeRuleModal;
